/*
 * If not stated otherwise in this file or this component's LICENSE file the
 * following copyright and licenses apply:
 *
 * Copyright 2020 Metrological
 *
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import Log from '../Log'
import { colorshiftShader } from './shaders'
import Announcer from './Announcer'

export default {
  Announcer,
  colorshift(component, type = false, config = { brightness: 50, contrast: 50, gamma: 50 }) {
    config = { ...{ brightness: 50, contrast: 50, gamma: 50 }, ...config }

    const shader = type && colorshiftShader(type)
    if (shader) {
      Log.info('Accessibility Colorshift', type, config)
      component.rtt = true
      component.shader = {
        type: shader,
        ...config,
      }
    } else {
      Log.info('Accessibility Colorshift', 'Disabled')
      component.rtt = false
      component.shader = null
    }
  },
}
